import listActions from 'src/modules/quizQuestion/list/quizQuestionListActions';
import QuizQuestionService from 'src/modules/quizQuestion/quizQuestionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'QUIZ_QUESTION_DESTROY';

const quizQuestionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionDestroyActions.DESTROY_STARTED,
      });

      await QuizQuestionService.destroyAll([id]);

      dispatch({
        type: quizQuestionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.quizQuestion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/quiz-question');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: quizQuestionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionDestroyActions.DESTROY_ALL_STARTED,
      });

      await QuizQuestionService.destroyAll(ids);

      dispatch({
        type: quizQuestionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.quiz.destroyAll.success'),
      );

      getHistory().push('/quiz');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: quizQuestionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default quizQuestionDestroyActions;
